import http from '@/plugins/axios';

export async function get_categories(payload) {
    let { type_id, type } = payload;
    const response = await http.get(`categories?type_id=${type_id}&type=restaurant`);
    return response.data.items;
}
export async function get_items(payload) {
    let { next_page, type, type_id, limit, category_id, search, order_type } = payload;
    const response = await http.get(`venueitems?type_id=${type_id}&type=restaurant&limit=${limit}&page=${next_page}&category_id=${category_id}&search=${search}&order_type=${order_type}`);
    return response.data;
}

